import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { getLabelClasses, getDataAttributes, getIconClasses } from './utils.js';
import { FAIcon } from '../fa-icon/component.js';
var GenericLabelIcon = function GenericLabelIcon(props) {
  var additionalClasses = props.additionalClasses,
    _props$fontWeight = props.fontWeight,
    fontWeight = _props$fontWeight === void 0 ? 'normal' : _props$fontWeight,
    icon = props.icon,
    _props$iconColor = props.iconColor,
    iconColor = _props$iconColor === void 0 ? 'gray' : _props$iconColor,
    _props$iconPosition = props.iconPosition,
    iconPosition = _props$iconPosition === void 0 ? 'left' : _props$iconPosition,
    iconSize = props.iconSize,
    type = props.type,
    position = props.position;
  if (!icon || iconPosition !== position) {
    return null;
  }
  var iconClasses = getIconClasses({
    fontWeight: fontWeight,
    type: type,
    iconColor: iconColor,
    iconPosition: iconPosition
  });
  return /*#__PURE__*/React.createElement("div", {
    className: iconClasses
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: icon,
    additionalClasses: additionalClasses,
    size: iconSize,
    color: iconColor
  }));
};
GenericLabelIcon.displayName = "GenericLabelIcon";
GenericLabelIcon.displayName = 'GenericLabelIcon';
var GenericLabel = function GenericLabel(props) {
  var additionalClasses = props.additionalClasses,
    _props$allowLineBreak = props.allowLineBreaks,
    allowLineBreaks = _props$allowLineBreak === void 0 ? false : _props$allowLineBreak,
    borderCurve = props.borderCurve,
    _props$bordered = props.bordered,
    bordered = _props$bordered === void 0 ? false : _props$bordered,
    className = props.className,
    dataAttributes = props.dataAttributes,
    _props$fontWeight2 = props.fontWeight,
    fontWeight = _props$fontWeight2 === void 0 ? 'normal' : _props$fontWeight2,
    icon = props.icon,
    _props$iconColor2 = props.iconColor,
    iconColor = _props$iconColor2 === void 0 ? 'gray' : _props$iconColor2,
    _props$iconPosition2 = props.iconPosition,
    iconPosition = _props$iconPosition2 === void 0 ? 'left' : _props$iconPosition2,
    iconSize = props.iconSize,
    label = props.label,
    type = props.type,
    value = props.value;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: getLabelClasses({
      allowLineBreaks: allowLineBreaks,
      borderCurve: borderCurve,
      bordered: bordered,
      className: className,
      label: label
    })
  }, getDataAttributes(dataAttributes)), /*#__PURE__*/React.createElement(GenericLabelIcon, {
    position: "left",
    additionalClasses: additionalClasses,
    fontWeight: fontWeight,
    icon: icon,
    iconColor: iconColor,
    iconPosition: iconPosition,
    iconSize: iconSize,
    type: type
  }), /*#__PURE__*/React.createElement(React.Fragment, null, value ? /*#__PURE__*/React.createElement("span", {
    className: "f-700"
  }, "".concat(label, ":"), "\xA0") : label, value), /*#__PURE__*/React.createElement(GenericLabelIcon, {
    position: "right",
    additionalClasses: additionalClasses,
    fontWeight: fontWeight,
    icon: icon,
    iconColor: iconColor,
    iconPosition: iconPosition,
    iconSize: iconSize,
    type: type
  }), ' ');
};
GenericLabel.displayName = "GenericLabel";
GenericLabel.displayName = 'GenericLabel';
export { GenericLabel };